/*
 * @Author: linjingcheng 1152691418@qq.com
 * @Date: 2022-09-27 13:39:10
 * @LastEditors: linjingcheng 1152691418@qq.com
 * @LastEditTime: 2022-10-01 13:47:00
 * @FilePath: \metabubble-join\src\App.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react';
import './App.css';
import LoginForm from './views/login-form-10/index.jsx';

function App() {

  return (
    <div style={{ width: '100vw', height: '100vh' }}>
        <LoginForm></LoginForm>
    </div>

  );
}

export default App;
